import { Controller } from 'stimulus'
import './component.scss'

// アコーディオンの開閉を制御するStimulusコントローラー
class AreaLinksController extends Controller {
  static targets = ['content', 'icon']

  connect() {
    // デフォルトで閉じた状態
    this.contentTarget.style.display = 'none'
  }

  toggle() {
    const isOpen = this.contentTarget.style.display !== 'none'

    if (isOpen) {
      // 閉じる
      this.contentTarget.style.display = 'none'
      this.iconTarget.classList.remove('area-links__icon--open')
    } else {
      // 開く
      this.contentTarget.style.display = 'block'
      this.iconTarget.classList.add('area-links__icon--open')
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('area-links', AreaLinksController)

export default AreaLinksController
